/**
 * Which Settings tab the URL asks for (`?tab=`). Pure, so `node --test` runs it.
 */

/** The tab to open: the asked one if it exists for this user, else the fallback (Account, criterion 1). */
export function tabFromSearch(param, allowed, fallback) {
	return param && allowed.includes(param) ? param : fallback
}

/**
 * The URL changed with the page mounted (a link with `?tab=`, e.g. Iris's "Change in Settings › Account"):
 * the tab to request, or `null` when there is nothing to change. The request still goes through the
 * unsaved-changes guard (TL, CU-869fknfmk plan-review block 3). A tab not allowed yet resolves to the
 * fallback, which is `null` while already there — so `?tab=acriss_group` arriving before the user data opens
 * that tab once the list includes it.
 */
export function resolveUrlTab({ current, param, allowed, fallback }) {
	if (!param) return null
	const want = tabFromSearch(param, allowed, fallback)
	return want === current ? null : want
}

/**
 * `?tab=iris` is now its own page (CU-869fmherf D4): the path to redirect to, or `null`. Only for Iris's
 * users — for the rest `?tab=iris` keeps opening Account (`tabFromSearch`). Never removed: saved chat
 * links and the ones Iris's brain writes still say `?tab=iris`.
 */
export const IRIS_TAB_PARAM = 'iris'
// `USER_ROUTES.IRIS_PATH`, spelt out: this file runs under `node --test`, without the `@constants` alias
export const IRIS_PAGE_PATH = '/user/iris'

export function irisRedirect({ param, isIris }) {
	return param === IRIS_TAB_PARAM && isIris ? IRIS_PAGE_PATH : null
}

/**
 * The Acriss groups tab is there for every user (CU-869fmhmx8 E6, P1 = A): the groups are the company's and the BI
 * dashboards filter by them. One Way's old page keeps redirecting to it, for everybody, so its links never 404.
 * Paths are passed in: this file runs under `node --test`, without the `@constants` alias.
 */
export const ACRISS_GROUPS_TAB = 'acriss_group'

export function settingsRedirects({ oneWayAcrissGroups, settings }) {
	return [{ path: oneWayAcrissGroups, to: `${settings}?tab=${ACRISS_GROUPS_TAB}` }]
}
